// No trailing slashes!
export const REPORTING_SERVICE_V2_PATH = '/api/reporting_service/v2';
